<div id="fab-dismiss" *ngIf="fabTogglerState==='active'" (click)="onToggleFab()">
</div>

<div class="fab-container">
  <button mat-fab class="fab-toggler" color="primary" (click)="onToggleFab()">
    <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">more_vert</i>
  </button>
  <div [@speedDialStagger]="buttons && buttons.length">
    <button *ngFor="let btn of buttons" appPreventDoubleClick mat-fab class="fab-secondary" color="accent" (throttledClick)="click(btn)" >
      <i *ngIf="btn.Icon" class="material-icons">{{btn.Icon}}</i>
      <span *ngIf="!btn.Icon">{{btn.Text}}</span>
    </button>
  </div>
</div>